import getParts from '../parts/getParts'

const parts = getParts()

export default parts
